<template>
  <div id="grid-asistencia">
    <div class="sub-titulo">
      <v-subheader class="sub-titu">
        - Proveedor: {{ nombreProveedor }}, Contrato: {{ codContrato }},
        Período: {{ perContrato }}</v-subheader
      >
    </div>
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-flex>
      <v-toolbar color="white" dark flat dense cad>
        <v-toolbar-title class="indigo--text"
          >Registros Asistencia&nbsp;
        </v-toolbar-title>
      </v-toolbar>
    </v-flex>
    <v-container grid-list-xl fluid>
      <v-layout justify-center>
        <v-flex xs12 md3>
          <v-textarea
            v-model="rutValue"
            label="RUTs: (Ej: xxxxxxxx-1, xxxxxxxx-2)"
          ></v-textarea>
        </v-flex>
        <v-flex xs12 md3>
          <v-text-field v-model="nombreValue" label="Nombre"></v-text-field>
        </v-flex>
        <v-flex xs12 md4>
          <v-menu
            v-model="menu1"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fechaIniFormatted"
                label="Fecha de inicio"
                prepend-icon="event"
                @click="menu1 = !menu1"
                @blur="fechaFinValue = parseDate(fechaIniFormatted)"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaIniValue"
              @input="menu1 = false"
              no-title
              locale="es"
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12 md4>
          <v-menu
            v-model="menu2"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="fechaFinFormatted"
                label="Fecha de fin"
                prepend-icon="event"
                @click="menu2 = !menu2"
                @blur="fechaFinValue = parseDate(fechaFinFormatted)"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="fechaFinValue"
              @input="menu2 = false"
              no-title
              locale="es"
              first-day-of-week="1"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <v-btn
          fab
          dark
          color="teal"
          title="Filtrar detalle"
          @click="loadData(true)"
        >
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-layout>
        <v-flex lg12>
          <div v-if="loading">
            <loading></loading>
          </div>
          <div v-if="alerta">
            <alert-empty></alert-empty>
          </div>
          <v-spacer></v-spacer>
          <template>
            <v-data-table
              :headers="headers"
              :items="itemsAsistencia"
              :rows-per-page-items="rowsPerPageItems"
              class="elevation-1"
              hide-actions
            >
              <template v-slot:items="props">
                <td class="text-xs-left">{{ props.item.validador.rut }}</td>
                <td class="text-xs-left">{{ props.item.validador.nombre }}</td>
                <td class="text-xs-left">{{ props.item.minutosStr }}</td>
                <td class="text-xs-left">{{ props.item.fechaIni }}</td>
                <td class="text-xs-left">{{ props.item.fechaFin }}</td>
                <td>
                  <v-btn
                    v-if="usuarioLoggedTipe != 'AGENCIA'"
                    depressed
                    outline
                    icon
                    fab
                    dark
                    color="red"
                    small
                    title="Eliminar registro"
                    @click="eliminar(props.item.id)"
                  >
                    <v-icon>clear</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
            <!-- LEYENDA -->
            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <v-btn
                v-if="usuarioLoggedTipe != 'AGENCIA'"
                depressed
                outline
                icon
                fab
                dark
                color="red"
                small
                title="Eliminar archivo"
              >
                <v-icon>clear</v-icon></v-btn
              >
              &nbsp;Eliminar registro
            </v-card-actions>

            <v-flex xs12 sm6>
              <v-text-field
                value=""
                label="Total de Registros"
                v-model="totalRegs"
                disabled
              ></v-text-field>
            </v-flex>
            <div class="text-center pt-2">
              <v-pagination
                @input="changePage(page)"
                v-model="page"
                :length="pages"
                :total-visible="9"
                circle
              >
              </v-pagination>
            </div>

            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
              <v-btn
                :loading="loading"
                :disabled="botonDescarga"
                color="primary"
                @click="descarga()"
                >Descarga<v-icon right dark>folder</v-icon></v-btn
              >
              <v-spacer></v-spacer>
            </v-card-actions>
            <v-dialog v-model="descargaLoading" persistent max-width="390">
              <loading-descarga></loading-descarga>
            </v-dialog>
          </template>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";

export default {
  name: "grid-asistencia",

  components: {
    AlertEmpty,
    Loading,
    LoadingDescarga,
  },
  props: {
    rowsTable: String,
    tipeView: String,
  },

  data() {
    return {
      loading: false,
      alerta: false,
      descargaLoading: false,
      botonDescarga: true,
      idContrato: 0,
      usuarioLoggedTipe: "",
      nombreProveedor: "",
      codContrato: "",
      perContrato: "",
      headers: [
        { text: "RUT", align: "left", sortable: false, value: "rut" },
        { text: "Nombre", align: "left", sortable: false, value: "nombre" },
        { text: "Horas", sortable: false, value: "horas" },
        { text: "Inicio", sortable: false, value: "inicio" },
        { text: "Termino", sortable: false, value: "termino" },
        { text: "Accion", sortable: false, value: "" },
      ],

      itemsAsistencia: [],
      idArchivoAsistecia: -1,
      rutValue: "",
      nombreValue: "",
      menu1: false,
      fechaIniValue: "",
      fechaIniFormatted: null,
      menu2: false,
      fechaFinValue: "",
      fechaFinFormatted: null,

      //paginacion por DB
      page: 1,
      pages: 1,
      totalRegs: 0,
      rowsPerPageItems: [20],
    };
  },
  watch: {
    fechaIniValue(val) {
      this.fechaIniFormatted = this.formatDate(this.fechaIniValue);
    },
    fechaFinValue(val) {
      this.fechaFinFormatted = this.formatDate(this.fechaFinValue);
    },
  },

  created() {
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;

    // console.log("st::this.$route:" + JSON.stringify(this.$route.query, null, 2));
    this.idContrato = this.$store.getters.contratoStored;
    this.idArchivoAsistecia = this.$route.query.idArchivoAsistecia;
    // console.log("this.idArchivoAsistecia:" + this.idArchivoAsistecia);
    this.nombreProveedor = this.$store.getters.nombreProveedorStored;
    this.codContrato = this.$store.getters.contratoCodStored;
    this.perContrato = this.$store.getters.contratoPerStored;

    this.loadData(true);
  },
  mounted() {},
  computed: {},
  methods: {
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      this.loadData();
    },
    async loadAsistencia() {
      let body = {
        idContrato: this.idContrato,
        idUsuario: this.$store.getters.userLogged.id,
        idArchivo: this.idArchivoAsistecia,
        rut: this.rutValue,
        nombre: this.nombreValue,
        fechaIni:
          this.fechaIniValue && this.fechaIniValue != null
            ? this.formatDate(this.fechaIniValue) + " 00:00"
            : null,
        fechaFin:
          this.fechaFinValue && this.fechaFinValue != null
            ? this.formatDate(this.fechaFinValue) + " 23:59"
            : null,
        pageSize: 20,
        pageNumber: this.page,
      };
      return await axios
        .post("/asistencia/getAsistencias/", body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            /*  window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message); */
          }
          return [];
        });
    },
    async loadData(limpiar) {
      if (limpiar) this.page = 1;
      this.loading = true;

      let result = await this.loadAsistencia();
      this.itemsAsistencia = result.asistencias;

      if (result.totalRegistros > 0) {
        this.totalRegs = result.totalRegistros;
        this.pages = Math.ceil(this.totalRegs / this.rowsPerPageItems);
        this.alerta = false;
        this.botonDescarga = false;
      } else {
        this.totalRegs = 0;
        this.page = 1;
        this.pages = 0;
        this.alerta = true;
        this.botonDescarga = true;
      }
      this.loading = false;
    },
    volver() {
      // setTimeout(() => {
      //   this.$router.push({
      //     name: "ValArchivo",
      //     params: { tabDefecto: "Asistencia" },
      //   });
      // }, 1000);
      this.$router.back();
    },
    clear() {
      this.rutValue = "";
      this.nombreValue = "";
      this.fechaIniValue = "";
      this.fechaFinValue = "";
      this.loadData(true);
    },
    descarga() {
      this.dialogLoading = true;
      let fileName = "Asistencia_Validadores.xlsx";

      var url = "/asistencia/descargaAsistencias/";
      this.body = {
        idContrato: this.idContrato,
        idUsuario: this.$store.getters.userLogged.id,
        idArchivo: this.idArchivoAsistecia,
        rut: this.rutValue,
        nombre: this.nombreValue,
        fechaIni:
          this.fechaIniValue && this.fechaIniValue != null
            ? this.formatDate(this.fechaIniValue) + " 00:00"
            : null,
        fechaFin:
          this.fechaFinValue && this.fechaFinValue != null
            ? this.formatDate(this.fechaFinValue) + " 23:59"
            : null,
        pageSize: 20,
        pageNumber: this.page,
      };
      axios
        .post(url, this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
          return [];
        });
    },
    eliminar(idAsistencia) {
      let body = {
        idContrato: this.idContrato,
        idAsistencia: idAsistencia,
        idUsuario: this.$store.getters.userLogged.id,
      };
      return axios
        .post("/asistencia/eliminarAsistencia/", body)
        .then((response) => {
          this.loadData(true);
        })
        .catch((error) => {
          if (error) {
            console.log(error.response.data);
            /*  window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message); */
          }
        });
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("-");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
  },
};
</script>
